import React, {Component} from "react";
import {withRouter} from "react-router-dom";
import {BackTop} from "antd";

class PrivacyCookiePolicy extends Component {
    render() {
        return (
            <div className="privacy-div">
                <BackTop/>
                <div className="container container_white_tab pt-5 privacy_container">
                    <div className="row">
                        <div className="col-lg-12">
                            <h3 className="event slide-left top in-view">
                                PURPOSE AND APPLICATION
                            </h3>
                            <div className="border_page  event slide-left bottom in-view"></div>
                            <p className="privacy-text">
                                This Privacy Policy explains how we collect, use, store, disclose and otherwise process
                                your Personal Data obtained through this Web Site and describes the rights you have with
                                respect to your Personal Data (“Privacy Policy”). Some online forms may have a specific
                                policy or privacy statement that differs from this Privacy Policy. Please review the
                                policy or privacy statement for any information that applies specifically to that form.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="container container_white_tab tab_top_spacing odd pt-3 pb-3 privacy_container">
                    <div className="row">
                        <div className="col-lg-12">
                            <h3 className="event slide-left top in-view">DEFINITIONS</h3>
                            <div className="border_page  event slide-left bottom in-view">
                                {" "}
                            </div>
                            <ul
                                className="event slide-left even in-view"
                                className="privacy-text"
                            >
                                <li>
                                    <strong>Cookies</strong> means small text files that are
                                    downloaded on the computer while visiting a website. The
                                    Cookie helps the website recognize a device for their next
                                    visit. They are widely used in order to make websites work, or
                                    work more efficiently, as well as to provide information to
                                    the owners of the website;
                                </li>
                                <li>
                                    <strong>Data Principal</strong> means the natural person to
                                    whom the Personal Data relates;
                                </li>
                                <li>
                                    <strong>Personal Data</strong> means data about or relating to
                                    a natural person who is directly or indirectly identifiable,
                                    having regard to any characteristic, trait, attribute or any
                                    other feature of the identity of such natural person, or any
                                    combination of such features, or any combination of such
                                    features with any other information;
                                </li>
                                <li>
                                    <strong>Personally Identifiable Information (PII)</strong>{" "}
                                    means any data that could potentially be used to identify a
                                    particular person. Examples includes first name, last name,
                                    mobile number, email addresses, ip addresses etc.;
                                </li>
                                <li>
                                    <strong>Privacy Policy</strong> means a legal document or
                                    statement that discloses some or all the ways a party gathers,
                                    uses, discloses and manages a customer’s or client’s data;
                                </li>
                                <li>
                                    <strong>Process or Processing</strong> in relation to personal
                                    data, means an operation or set of operations performed on
                                    personal data, and may include operations such as collection,
                                    recording, organization, structuring, storage, adaptation,
                                    alteration, retrieval, use, alignment or combination,
                                    indexing, disclosure by transmission, dissemination or
                                    otherwise making available, restriction, erasure or
                                    destruction;
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="container container_white_tab tab_top_spacing odd pt-3 pb-3">
                    <div className="row">
                        <div className="col-lg-12">
                            <h3 className="event slide-left top in-view">
                                PERSONAL INFORMATION THAT YOU CHOOSE TO SUBMIT
                            </h3>
                            <div className="border_page  event slide-left bottom in-view">
                                {" "}
                            </div>
                            <p className="privacy-text">
                                ArcelorMittal Nippon Steel India Private Limited Web Site’s various registration forms
                                and surveys
                                may request that you give us contact information (such as your
                                name, mailing and/or e-mail address) and profile data (such as
                                your preferences). In many cases, you choose the amount of
                                information you supply (e.g. when sending us information through
                                the site, you may choose to include only an e-mail address for
                                replies). There may be cases, however, where some of the
                                information requested is identified as mandatory and some as
                                voluntary. In such cases, if you do not provide mandatory
                                personal information with respect to a particular activity, you
                                will not be able to receive the applicable services.
                            </p>
                            <p className="privacy-text">
                                If you request information through this Web Site and supply ArcelorMittal Nippon Steel
                                India Private Limited with your e-mail address or your name and postal address, you
                                accept that this data will be used for the purpose
                                of providing the requested information and that AM/NS India may
                                use this data in the future to provide other information about
                                AM/NS India that might be of interest to you.
                            </p>
                            <p className="privacy-text">
                                ArcelorMittal Nippon Steel India Private Limited may disclose user information in
                                special cases when we have reasons to believe that disclosing this information is
                                necessary to identify, contact or bring legal action against someone who may be causing
                                injury to or interference (either intentionally or unintentionally) with ArcelorMittal
                                Nippon Steel India Private Limited’s rights or property, other users of the Web Site, or
                                anyone else who could be harmed by such activities.
                            </p>
                            <p className="privacy-text">
                                PII is never sold or leased to any third parties outside of ArcelorMittal Nippon Steel
                                India Private Limited group. We may share information provided by you with service
                                providers we have retained to perform services on our behalf. In this case, the service
                                provider is committed to use your data only for ArcelorMittal Nippon Steel India Private
                                Limited purposes. </p>
                        </div>
                    </div>
                </div>
                <div className="container container_white_tab tab_top_spacing odd pt-3 pb-3 privacy_container">
                    <div className="row">
                        <div className="col-lg-12">
                            <h3 className="event slide-left top in-view">
                                PROCESSING OF PERSONAL DATA{" "}
                            </h3>
                            <div className="border_page  event slide-left bottom in-view">
                                {" "}
                            </div>
                            <p className="privacy-text">
                                ArcelorMittal Nippon Steel India Private Limited may Process your Personal Data where
                                where such relevant
                                PII is required to be Processed for the following, but not
                                limited to, ArcelorMittal Nippon Steel India Private Limited purposes:
                            </p>
                            <ul className="privacy-text">
                                <li>Processing applications for products and services;</li>
                                <li>
                                    Providing products and services; (It is not feasible for an
                                    organization to provide product / service without Processing);
                                </li>
                                <li>Monitoring and improving our Web Site and its content;</li>
                                <li>
                                    Conducting market research and surveys with the aim of
                                    improving our products and services;
                                </li>
                                <li>
                                    Sending you information about our products and services for
                                    marketing purposes and promotions;
                                </li>
                                <li>
                                    Complying with applicable local or foreign law, regulation,
                                    policy, voluntary codes, directive, judgement or court order,
                                    as well as any contractual obligation pursuant to agreements between ArcelorMittal
                                    Nippon Steel India Private and any authority, regulator or
                                    enforcement agency or body or any request coming from said
                                    entities;
                                </li>
                                <li>
                                    Establishing, exercising or defending legal rights in
                                    connection with legal proceedings (including any prospective
                                    legal proceedings) and seeking professional or legal advice in
                                    relation to such legal proceedings.
                                </li>
                            </ul>
                            <p className="privacy-text">
                                ArcelorMittal Nippon Steel India Private Limited Processes your Personal Data for the
                                performance of
                                the contracts/agreements concluded with you, compliance with
                                applicable legal or regulatory obligations or ArcelorMittal Nippon Steel India Private
                                Limited
                                legitimate interests to provide you with adequate and
                                qualitative products and services and to prevent against any
                                substantial risk.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="container container_white_tab pt-3 privacy_container">
                    <div className="row">
                        <div className="col-lg-12">
                            <h3 className="event slide-left top in-view">
                                ACCESS TO PERSONAL DATA
                            </h3>
                            <div className="border_page  event slide-left bottom in-view">
                                {" "}
                            </div>
                            <p className="privacy-text">
                                Your Personal Data Processed by ArcelorMittal Nippon Steel India Private Limited will
                                only be
                                accessible by a limited list of recipients on a need to know
                                basis or where required by law.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="container container_white_tab pt-3 privacy_container">
                    <div className="row">
                        <div className="col-lg-12">
                            <h3 className="event slide-left top in-view">COOKIES </h3>
                            <div className="border_page  event slide-left bottom in-view">
                                {" "}
                            </div>
                            <p className="privacy-text">
                                Cookies can be used for a variety of purposes such as remembering your preference,
                                measuring your activity and optimizing your user experience. When consulting the
                                ArcelorMittal Nippon Steel India Private Limited Web Site, Cookies may get placed on
                                your computer, mobile or tablet. Cookies could contain the following data:
                            </p>
                            <ul className="privacy-text">
                                <li>
                                    Information about the browser; an identifier, in the form of a
                                    unique identification number.
                                </li>
                                <li>An expiration date (some Cookies only)</li>
                            </ul>
                            <p className="privacy-text">
                                Cookies used by ArcelorMittal Nippon Steel India Private Limited and its purpose.
                            </p>
                            <h5 className="privacy event slide-left even in-view">
                                Following are the Cookies we use and why:
                            </h5>
                            <ul className="privacy-text">
                                <li>
                                    <strong>
                                        Security Cookies (csrf; session; YSC; demographics; DKV)
                                    </strong>
                                    <br/>
                                    We embed videos from our official YouTube channel using
                                    YouTube’s privacy-enhanced mode. This mode may set Cookies on
                                    your computer once you click on the YouTube video player, but
                                    YouTube will not store PII Cookie information for playbacks of
                                    embedded videos using the privacy-enhanced mode. Read more at
                                    YouTube’s embedding videos information page.
                                </li>
                            </ul>
                            <h5 className="privacy event slide-left even">
                                Purpose for which Cookies are used
                            </h5>
                            <h5 className="privacy event slide-left even">
                                Generally, Cookies perform the following functions:
                            </h5>
                            <ul className="privacy-text">
                                <li>
                                    Enabling our Web Site to function properly - Some Cookies are
                                    essential for the functioning of our Web Site. For example,
                                    Cookies ensure that you are shown the correct webpages for
                                    your location, or to identify when we have a broken link or
                                    technical issue with the Web Site.
                                </li>
                                <li>
                                    Optimizing and personalizing - Cookies are used to optimize
                                    the webpages that you visit and to personalize the content
                                    that is shown to you across all our digital assets, based on
                                    our understanding of your requirement.
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="container container_white_tab tab_top_spacing odd pt-3 pb-3 privacy_container">
                    <div className="row">
                        <div className="col-lg-12">
                            <h3 className="event slide-left top in-view">
                                RETENTION OF PERSONAL DATA
                            </h3>
                            <div className="border_page  event slide-left bottom in-view">
                                {" "}
                            </div>
                            <p className="event slide-left even in-view">
                                Your Personal Data being Processed by ArcelorMittal Nippon Steel India Private Limited
                                is stored for
                                the purpose for which it was collected in line with legal,
                                regulatory or statutory obligations and in such form, which is
                                identifiable to the extent necessary. In situations where the
                                purpose is fulfilled or where the specified period has expired,
                                your Personal Data will be deleted or archived to comply with
                                legal retention obligations in accordance with the law.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="container container_white_tab pt-3 pb-3 privacy_container">
                    <div className="row">
                        <div className="col-lg-12">
                            <h3 className="event slide-left top in-view">
                                ACCESS AND CONTROL YOUR PERSONAL DATA
                            </h3>
                            <div className="border_page  event slide-left bottom in-view">
                                {" "}
                            </div>
                            <p className="privacy-text">
                                Subject to applicable law, regulations and/or guidelines, you
                                may have the right to Data Principal’s right in relation to your
                                Personal Data being collected, used, Processed and stored by the Company. ArcelorMittal
                                Nippon Steel India Private Limited shall provide information to the Data
                                Principal on a request pertaining to Data Principal’s rights
                                without undue delay and within one month of receipt of the
                                request. This period can be extended considering the complexity
                                and number of requests. The extension shall be reasoned with
                                proper notice for delay.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="container container_white_tab tab_top_spacing odd pt-3 pb-3 privacy_container">
                    <div className="row">
                        <div className="col-lg-12">
                            <h3 className="event slide-left top in-view">SECURITY </h3>
                            <div className="border_page  event slide-left bottom in-view">
                                {" "}
                            </div>
                            <p className="privacy-text">
                                Security for all PII is extremely important to us. Once we
                                receive your transmission, we make our best efforts to ensure
                                its security on our systems. Unfortunately, no data transmission
                                over the internet can be guaranteed to be 100% secure. As a
                                result, while we strive to protect your personal information, ArcelorMittal Nippon Steel
                                India Private cannot ensure or warrant the security of any
                                information you transmit to us.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="container container_white_tab pt-3 privacy_container">
                    <div className="row">
                        <div className="col-lg-12">
                            <h3 className="event slide-left top in-view">
                                CHANGES TO THIS PRIVACY POLICY{" "}
                            </h3>
                            <div className="border_page  event slide-left bottom in-view">
                                {" "}
                            </div>
                            <p className="privacy-text">
                                This Privacy Policy may be updated periodically and without
                                prior notice to you to changes in our online information practices. ArcelorMittal Nippon
                                Steel India Private has sole discretion in updation of this
                                policy. When changes are made to this policy it will be posted
                                on the Web Site and the "last updated" date at the top of this
                                policy will be revised. We also encourage users to periodically
                                check this policy understand how ArcelorMittal Nippon Steel India Private Limited
                                protects, uses and protects, uses
                                and Processes your information/ data.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="container container_white_tab tab_top_spacing odd pt-3 pb-3 privacy_container">
                    <div className="row">
                        <div className="col-lg-12">
                            <h3 className="event slide-left top in-view">CONTACT </h3>
                            <div className="border_page  event slide-left bottom in-view">
                                {" "}
                            </div>
                            <p className="privacy-text">
                                If you have any questions about this Privacy Policy, the
                                practices of our sites, or your dealings with our sites, you can contact: ArcelorMittal
                                Nippon Steel India Private Limited.
                            </p>
                            <p className="privacy-text">
                                Information provided by you via general e-mail inquiries to
                                AM/NS India such as your e-mail address is used only to respond
                                to your inquiries in the ordinary course of business, and is
                                never shared with third parties.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="container container_white_tab pt-3 privacy_container">
                    <div className="row">
                        <div className="col-lg-12">
                            <h3 className="event slide-left top in-view">JURISDICTION </h3>
                            <div className="border_page  event slide-left bottom in-view">
                                {" "}
                            </div>
                            <p className="privacy-text">
                                Please be informed that any proceedings arising out of or
                                relating to your use of this Web Site, its content and services
                                will be subject to the laws of India and the Courts in Mumbai,
                                India shall have exclusive jurisdiction.
                            </p>
                            <p className="privacy-text">
                                If you have any questions about this privacy policy, the practices of our Sites, or your
                                dealings with our Sites, you can contact: AMNS Legal department:
                            </p>
                            <p className="privacy-text">
                                ArcelorMittal Nippon Steel India Limited
                                <br/>
                                <br/>
                                Registered Office
                                <br/>
                                <br/>
                                27 km, Surat-Hazira Road,<br/>
                                Hazira, Surat - 394270,<br/>
                                Gujarat , India<br/>
                                <hr/>
                                Corporate Office<br/>
                                <br/>
                                Raheja Towers, 6th & 7th Floor,<br/>
                                BKC, Bandra East, Mumbai - 400051,<br/>
                                Maharashtra, India<br/>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(PrivacyCookiePolicy);
